<template>
  <el-dialog
    class="process-mind-map-dialog process-mind-map-source-dialog tree-bom-detail-dialog"
    :visible.sync="innerVisible"
    width="96vw"
    append-to-body
    top="4vh"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @open="loadData"
    @closed="resetData">
    <div slot="title" class="tree-bom-detail-dialog__title">
      <span>{{ $LANG('', '树状BOM表') }}</span>
    </div>
    <div
      class="tree-bom-detail-dialog__body"
      v-loading="loading"
      :element-loading-text="$LANG('1959', '加载中')"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(255, 251, 255, 0.72)">
      <div class="tree-bom-detail-dialog__grid">
        <section class="tree-bom-panel tree-bom-panel--tree">
          <div class="tree-bom-panel__title tree-bom-panel__title--actions">
            <span class="tree-bom-panel__heading">{{ $LANG('2094', '树状工艺') }}</span>
            <el-button
              class="tree-bom-panel__export"
              type="text"
              size="mini"
              icon="el-icon-download"
              :disabled="!treeData.length"
              :loading="exportLoading"
              @click="exportFullBom">
              {{ $LANG('', '导出') }}
            </el-button>
          </div>
          <div class="tree-bom-panel__content">
            <el-tree
              v-if="treeData.length"
              ref="bomTree"
              class="tree-bom-detail-dialog__tree"
              :data="treeData"
              :props="defaultProps"
              node-key="id"
              default-expand-all
              highlight-current
              :expand-on-click-node="false"
              @node-click="handleTreeNodeClick">
              <template v-slot="{ node, data }">
                <span class="tree-bom-node" :class="{ 'tree-bom-node--root': data.parentid === '#' }">
                  <i :class="data.parentid === '#' ? 'iconfont icon-kucunguanli' : 'iconfont icon-fenzhijiedian'"></i>
                  <span class="tree-bom-node__label" :title="getTreeNodeTitle(node, data)">
                    {{ node.label }}<template v-if="data.parentid === '#'">【{{ rootMatno }} : {{ data.icon }}】</template><template v-else> {{ data.icon }}</template>
                  </span>
                </span>
              </template>
            </el-tree>
            <div v-else class="tree-bom-detail-dialog__empty">{{ $LANG('', '暂无数据') }}</div>
          </div>
        </section>

        <section class="tree-bom-panel tree-bom-panel--detail">
          <div class="tree-bom-panel__title">{{ $LANG('0719', '工序物料') }}</div>
          <div class="tree-bom-panel__content">
            <el-table
              :data="dtlData"
              border
              size="small"
              ref="dtlTable"
              class="custom-table-border tree-bom-detail-dialog__table"
              height="100%"
              v-loading="dtlLoading"
              :element-loading-text="$LANG('1959', '加载中')"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255, 255, 255, .72)"
              :cell-style="{ padding: '2px' }"
              :header-cell-style="{ color: '#389', textAlign: 'center' }"
              cell-class-name="clearPadding"
              highlight-current-row>
              <el-table-column :label="$LANG('0310', '序号')" type="index" width="55"></el-table-column>
              <el-table-column
                v-for="item in visibleDtlColumns"
                :key="item.key"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"
                :sortable="item.sortable === 'N'"
                :min-width="item.width">
                <template slot-scope="scope">
                  <el-checkbox
                    v-if="item.edcss === 'checkbox'"
                    disabled
                    true-label="Y"
                    false-label="N"
                    v-model="scope.row[item.key]">
                  </el-checkbox>
                  <span v-else v-text="displayText(scope.row[item.key])"></span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </section>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { getTabColOrData } from '../../api/user'

export default {
  name: 'TreeBomDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    node: {
      type: Object,
      default: function () { return null }
    }
  },
  data: function () {
    return {
      loading: false,
      dtlLoading: false,
      exportLoading: false,
      treeData: [],
      dtlData: [],
      dtlColumns: [],
      rootMatno: '',
      rootCorpid: '',
      treeid: '',
      selectedBomty: '',
      defaultProps: {
        children: 'children',
        id: 'id',
        icon: 'icon',
        parentid: 'parentid',
        label: 'label',
        flag: 'flag',
        idseq: 'idseq',
        lvl: 'lvl',
        stfg: 'stfg'
      }
    }
  },
  computed: {
    innerVisible: {
      get: function () { return this.visible },
      set: function (value) { this.$emit('update:visible', value) }
    },
    vUsername: function () {
      return this.$cookies.get('v_telno')
    },
 
 
    tableUrl: function () {
      return   'xuper_auth/getTableRecMany'
    },
    visibleDtlColumns: function () {
      return (this.dtlColumns.length ? this.dtlColumns : this.getFallbackDtlColumns()).filter(function (item) { return item.thide === 'N' })
    }
  },
  methods: {
    resetData: function () {
      this.loading = false
      this.dtlLoading = false
      this.exportLoading = false
      this.treeData = []
      this.dtlData = []
      this.dtlColumns = []
      this.rootMatno = ''
      this.rootCorpid = ''
      this.treeid = ''
      this.selectedBomty = ''
    },
    loadData: function () {
      var params
      try {
        params = this.getRequiredSourceParams()
      } catch (error) {
        this.treeData = []
        return
      }
      this.rootMatno = params.MATNO
      this.rootCorpid = params.CORPID
      this.treeid = params.MATNO
      this.loading = true
      Promise.all([
        this.loadColumns(),
        this.loadTree(params.MATNO, params.CORPID).catch(function (error) {
          this.handleLoadError(error, params.MATNO)
          return []
        }.bind(this))
      ]).then(function (result) {
        var columns = result[0] || {}
        this.dtlColumns = columns.dtlColumns || []
        this.treeData = result[1] || []
        if (this.treeData.length) {
          this.$nextTick(function () {
            if (this.$refs.bomTree && this.$refs.bomTree.setCurrentKey) this.$refs.bomTree.setCurrentKey(this.rootMatno)
            this.loadBomDetail(this.rootMatno)
          })
        }
      }.bind(this)).catch(function (error) {
        this.$emit('error', (error && error.message) || this.$LANG('1442', '提示'))
      }.bind(this)).finally(function () {
        this.loading = false
      }.bind(this))
    },
    loadColumns: function () {
      return Promise.all([
        this.loadColumnRows('2')
      ]).then(function (result) {
        return {
          dtlColumns: result[0] || []
        }
      })
    },
    loadColumnRows: function (lstseq) {
      return getTabColOrData(this.tableUrl, 'v_sys_form_fld', 'idseq', '16532', 'lstseq', lstseq, '', '', ' order by sortby,lstseq').then(function (res) {
        var list = (res && res.result) || []
        return list.map(function (item) {
          return {
            title: this.$translate.getColTitle(item, this.$store.state.lang),
            key: item.key,
            align: item.align,
            width: item.width,
            thide: item.THIDE,
            edcss: item.EDCSS,
            sortable: item.SORTABLE
          }
        }.bind(this))
      }.bind(this)).catch(function () {
        return []
      })
    },
    loadTree: function (matno, corpid) {
      return this.$axios({
        method: 'post',
        url:   'xuper_auth/getLoopData',
        data: {
          p_table: 'V_TREE_BOM',
          p_cond: " and corpid='" + this.escapeQueryValue(corpid) + "'",
          p_value: matno
        }
      }).then(function (res) {
        if (res && res.code === '200') return (res && res.result) || []
        var message = (res && res.result) || ''
        var error = new Error(message || this.$LANG('1442', '提示'))
        error.responseMessage = message
        throw error
      }.bind(this))
    },
    handleTreeNodeClick: function (data) {
      data = data || {}
      this.treeid = data.id || ''
      this.selectedBomty = data.bomty || ''
      this.loadBomDetail(data.id)
    },
    loadBomDetail: function (matno) {
      if (!matno || !this.rootMatno || !this.rootCorpid) return
      this.dtlLoading = true
      this.dtlData = []
      this.loadMainBomRows().then(function (rows) {
        if (!rows.length) return []
        return this.loadDtlList(rows[0].IDSEQ, matno, matno === this.rootMatno)
      }.bind(this)).then(function (rows) {
        this.dtlData = rows || []
        this.$nextTick(function () {
          if (this.$refs.dtlTable && this.$refs.dtlTable.doLayout) this.$refs.dtlTable.doLayout()
        })
      }.bind(this)).catch(function () {
        this.dtlData = []
      }.bind(this)).finally(function () {
        this.dtlLoading = false
      }.bind(this))
    },
    loadMainBomRows: function () {
      return getTabColOrData(this.tableUrl, 'v_PRD_bom', 'matno', this.rootMatno, 'corpid', this.rootCorpid, '', '', '').then(function (res) {
        return (res && res.result) || []
      })
    },
    loadDtlList: function (idseq, matno, isRoot) {
      var escapedMatno = this.escapeQueryValue(matno)
      var conditionKey = typeof isRoot === 'boolean'
        ? (isRoot ? 'parentno' : 'code')
        : (this.treeid === this.rootMatno ? 'parentno' : 'code')
      var sql = "select * from (SELECT LVL,MATNO,MATNM,MATTYNM,SPECNM,BOMUNITNM,QTY,POSITION,RMK,IDSEQ,LSTSEQ,BOMFLAG,ADDUSER,ADDDTTM FROM V_PRD_BOMDTL START WITH IDSEQ=" + idseq + " and " + conditionKey + "='" + escapedMatno + "' CONNECT BY PRIOR CODE=PARENTNO ) where matno like 'm%'"
      return this.$axios({
        method: 'post',
        url:   'xuper_auth/getFreeData' ,
        data: { p_cond: sql }
      }).then(function (res) {
        return (res && res.result) || []
      })
    },
    flattenBomTree: function (nodes, parent, level) {
      var result = []
      var currentLevel = level || 1
      ;(nodes || []).forEach(function (node) {
        result.push({ node: node, parent: parent || null, level: currentLevel })
        result = result.concat(this.flattenBomTree(node.children || [], node, currentLevel + 1))
      }.bind(this))
      return result
    },
    getBomExportColumns: function () {
      return [
        { title: '物料编码', key: 'MATNO' },
        { title: '物料名称', key: 'MATNM' },
        { title: '用量', key: 'QTY' },
        { title: '物料描述', key: 'SPECNM' },
        { title: 'BOM单位', key: 'BOMUNITNM' },
        { title: '电路位置', key: 'POSITION' },
        { title: '预制件', key: 'BOMFLAG' },
        { title: '工艺说明', key: 'RMK' },
        { title: '新增用户', key: 'ADDUSER' },
        { title: '新增日期', key: 'ADDDTTM' }
      ]
    },
    buildBomExportData: function (detailGroups) {
      var exportColumns = this.getBomExportColumns()
      var headers = exportColumns.map(function (column) { return column.title })
      var rows = []
      ;(detailGroups || []).forEach(function (details) {
        details.forEach(function (detail) {
          rows.push(exportColumns.map(function (column) {
            var value = detail[column.key]
            return value === undefined || value === null ? '' : value
          }))
        })
      })
      return { headers: headers, rows: rows }
    },
    collectBomExportData: function () {
      return this.loadMainBomRows().then(function (mainRows) {
        if (!mainRows.length) throw new Error('NO_TREE_BOM_EXPORT_DATA')
        return this.loadDtlList(mainRows[0].IDSEQ, this.rootMatno, true)
      }.bind(this)).then(function (detailGroups) {
        return this.buildBomExportData([detailGroups])
      }.bind(this))
    },
    getBomExportFileName: function (date) {
      var nodeData = this.getNodeData()
      var sourceOrderRow = (this.node && this.node.sourceOrderRow) || {}
      var orderNo = sourceOrderRow.ORDNO || nodeData.ORDNO || nodeData.IDNO || nodeData.REFIDNO || (this.node && this.node.refidno) || '订单'
      var skuNo = sourceOrderRow.MATNO || nodeData.MATNO || this.rootMatno || 'SKU'
      var currentDate = date || new Date()
      var month = ('0' + (currentDate.getMonth() + 1)).slice(-2)
      var day = ('0' + currentDate.getDate()).slice(-2)
      var dateText = currentDate.getFullYear() + '-' + month + '-' + day
      var sanitize = function (value) {
        return String(value).trim().replace(/[\\/:*?"<>|]/g, '_')
      }
      return sanitize(orderNo) + '—' + sanitize(skuNo) + '—' + dateText
    },
    downloadBomExcel: function (exportData) {
      return import('../../plugin/Export2Excel').then(function (excel) {
        excel.export_json_to_excel(exportData.headers, exportData.rows, this.getBomExportFileName())
      }.bind(this))
    },
    exportFullBom: function () {
      if (this.exportLoading || !this.treeData.length) return
      this.exportLoading = true
      this.collectBomExportData().then(function (exportData) {
        return this.downloadBomExcel(exportData)
      }.bind(this)).catch(function (error) {
        var message = error && error.message === 'NO_TREE_BOM_EXPORT_DATA'
          ? this.$LANG('', '暂无可导出的BOM数据')
          : ((error && error.message) || this.$LANG('', '导出失败'))
        this.$emit('error', message)
      }.bind(this)).finally(function () {
        this.exportLoading = false
      }.bind(this))
    },
    getNodeData: function () {
      return (this.node && this.node.nodeData) || {}
    },
    getRequiredSourceParams: function () {
      var row = this.getNodeData()
      var params = {
        MATNO: row.MATNO,
        CORPID: row.CORPID
      }
      if (params.MATNO === undefined || params.MATNO === null || params.MATNO === '') throw new Error('MISSING_TREE_BOM_PARAMS')
      if (params.CORPID === undefined || params.CORPID === null || params.CORPID === '') throw new Error('MISSING_TREE_BOM_PARAMS')
      return params
    },
    handleLoadError: function (error, matno) {
      var message = (error && (error.responseMessage || error.message)) || ''
      if (message.indexOf('ORA-01436') > -1) {
        this.$emit('error', this.$LANG('1221', '在查询母件为：') + matno + ' BOM' + this.$LANG('1942', '的层级结构中发现死循环，可能子件的层级结构含有母件产品编码，请检查'))
      } else if (message) {
        this.$emit('error', message)
      }
    },
    escapeQueryValue: function (value) {
      return String(value === undefined || value === null ? '' : value).trim().replace(/'/g, "''")
    },
    displayText: function (value) {
      return value === undefined || value === null || value === '' ? '-' : value
    },
    getTreeNodeTitle: function (node, data) {
      node = node || {}
      data = data || {}
      return data.parentid === '#' ? (node.label + '【' + this.rootMatno + ' : ' + data.icon + '】') : (node.label + ' ' + data.icon)
    },
    getFallbackDtlColumns: function () {
      return [
        { title: '层级', key: 'LVL', align: 'center', width: 70, thide: 'N', sortable: 'N' },
        { title: '物料编码', key: 'MATNO', align: 'left', width: 120, thide: 'N', sortable: 'N' },
        { title: '物料名称', key: 'MATNM', align: 'left', width: 180, thide: 'N', sortable: 'N' },
        { title: '物料类型', key: 'MATTYNM', align: 'left', width: 120, thide: 'N', sortable: 'N' },
        { title: '规格', key: 'SPECNM', align: 'left', width: 150, thide: 'N', sortable: 'N' },
        { title: '单位', key: 'BOMUNITNM', align: 'center', width: 80, thide: 'N', sortable: 'N' },
        { title: '数量', key: 'QTY', align: 'right', width: 90, thide: 'N', sortable: 'N' },
        { title: '位置', key: 'POSITION', align: 'left', width: 120, thide: 'N', sortable: 'N' },
        { title: '备注', key: 'RMK', align: 'left', width: 150, thide: 'N', sortable: 'N' }
      ]
    }
  }
}
</script>

<style scoped>
.tree-bom-detail-dialog__title {
  display: flex;
  align-items: center;
  min-height: 40px;
  padding: 0 56px 0 20px;
  color: #1d1d1f;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
}
.tree-bom-detail-dialog__body {
  height: 78vh;
  min-height: 520px;
  padding: 16px;
  box-sizing: border-box;
  overflow: hidden;
  background: #f5f5f7;
}
.tree-bom-detail-dialog__grid {
  display: grid;
  grid-template-columns: 25% 75%;
  gap: 12px;
  height: 100%;
  min-height: 0;
}
.tree-bom-panel {
  display: flex;
  min-width: 0;
  min-height: 0;
  flex-direction: column;
  border: 1px solid rgba(60, 60, 67, .12);
  border-radius: 11px;
  background: #fff;
  overflow: hidden;
}
.tree-bom-panel__title {
  flex: none;
  min-height: 36px;
  padding: 0 12px;
  border-bottom: 1px solid rgba(60, 60, 67, .12);
  color: #1d1d1f;
  font-size: 14px;
  font-weight: 600;
  line-height: 36px;
}
.tree-bom-panel__title::before {
  content: '';
  display: inline-block;
  width: 4px;
  height: 16px;
  margin-right: 8px;
  border-radius: 2px;
  background: #0066cc;
  vertical-align: -3px;
}
.tree-bom-panel__title--actions {
  display: flex;
  align-items: center;
  line-height: normal;
}
.tree-bom-panel__heading {
  min-width: 0;
  flex: 1 1 auto;
  line-height: 36px;
  white-space: nowrap;
}
.tree-bom-panel__export {
  flex: none;
  margin-left: 8px;
  padding: 5px 4px;
}
.tree-bom-panel__content {
  flex: 1 1 auto;
  min-height: 0;
  padding: 10px;
  overflow: auto;
}
.tree-bom-detail-dialog__tree {
  min-width: 100%;
  min-height: 100%;
}
.tree-bom-node {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  gap: 4px;
  color: #2b85e4;
  font-size: 12px;
  line-height: 22px;
}
.tree-bom-node--root {
  color: #409eff;
  font-size: 14px;
  font-weight: 600;
}
.tree-bom-node i {
  flex: none;
  color: #e6a23c;
  font-size: 14px;
}
.tree-bom-node--root i {
  color: #409eff;
  font-size: 18px;
}
.tree-bom-node__label {
  display: inline-block;
  max-width: 220px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tree-bom-detail-dialog__table {
  width: 100%;
}
.tree-bom-detail-dialog__empty {
  min-height: 120px;
  padding: 40px 0;
  border: 1px dashed rgba(60, 60, 67, .12);
  border-radius: 11px;
  color: #8e8e93;
  font-size: 14px;
  line-height: 22px;
  text-align: center;
}
.tree-bom-detail-dialog__empty--compact {
  min-height: 80px;
  padding: 24px 0;
}
</style>

<style lang="less">
.process-mind-map-dialog.tree-bom-detail-dialog {
  .el-dialog {
    max-width: 1600px;
  }
  .el-dialog__header {
    padding: 0;
  }
  .el-tree-node__content {
    height: 28px;
    border-radius: 8px;
  }
  .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
    background: rgba(0, 102, 204, .10);
  }
  .tree-bom-panel__content::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  .tree-bom-panel__content::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: rgba(60, 60, 67, .26);
  }
  .tree-bom-panel__content::-webkit-scrollbar-track {
    border-radius: 999px;
    background: rgba(60, 60, 67, .08);
  }
}
</style>
